import { render } from "./InterView.vue?vue&type=template&id=2fb8cfce&scoped=true"
import script from "./InterView.vue?vue&type=script&lang=js"
export * from "./InterView.vue?vue&type=script&lang=js"

import "./InterView.vue?vue&type=style&index=0&id=2fb8cfce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb8cfce"]])

export default __exports__